import {Link, Image} from '@shopify/hydrogen';
import Skeleton from 'react-loading-skeleton';
import {WhiskyBarType} from '../../../types';

interface WhiskyBarCardProps {
  whiskyBar?: WhiskyBarType;
}

export default function WhiskyBarCard({whiskyBar}: WhiskyBarCardProps) {
  const barLink = whiskyBar ? `/bars/${whiskyBar.slug}/` : '#';
  return (
    <Link to={barLink} className="list-type-3__item">
      <div className="list-type-3__image">
        {!whiskyBar ? (
          <Skeleton height="100%" />
        ) : (
          <picture>
            {whiskyBar.images.length > 0 &&
              whiskyBar.images[0]?.image_desktop_webp && (
                <source srcSet={whiskyBar.images[0].image_desktop_webp} />
              )}
            {whiskyBar.images.length > 0 && (
              <>
                <source
                  srcSet={whiskyBar.images[0].image_mobile_jpeg}
                  type="image/jpeg"
                />
                <Image
                  width={1400}
                  height={500}
                  src={whiskyBar.images[0].image_mobile_jpeg}
                  alt="whisky bar image"
                />
              </>
            )}
          </picture>
        )}
        {whiskyBar?.is_partner && (
          <div className="list-type-3__label tag-element">Partner</div>
        )}
      </div>
      <h6 className="list-type-3__location">
        {!whiskyBar ? (
          <Skeleton />
        ) : (
          <>
            {whiskyBar.state.name}
            {whiskyBar.suburb ? ` - ${whiskyBar.suburb}` : ''}
          </>
        )}
      </h6>
      <h3 className="list-type-3__title title-2">
        {!whiskyBar ? <Skeleton /> : whiskyBar.name}
      </h3>
    </Link>
  );
}
